// extracted by mini-css-extract-plugin
export default {"container":"FrequencyModal_container__rwhQb"};